/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  alerts: [],
  alert: Object,
}


// WEBPACK FOOTER //
// ./src/store/modules/alerts/state.js